export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 17-1493a5f439d60b9ce99f3738a130cd58.png";